<template>
  <b-button-group
    class="toggle-switch"
    :class="{'icons-only': iconsOnly, 'w-100': !iconsOnly}">
    <app-button
      class="toggle-switch__item app-button"
      :iconOnly="iconsOnly"
      :loading="loading"
      :style="{
        width: buttonWidth
      }"
      :variant="option.value === value ? 'primary' : 'outline-secondary'"
      :title="option.title"
      v-for="(option, index) in options"
      :key="index"
      :size="small ? 'sm' : ''"
      @click="onOptionClick(option.value)">
        <i v-if="option.icon" :class="[option.icon]"></i>
        <span v-if="!iconsOnly">{{ option.text }}</span>
    </app-button>
  </b-button-group>
</template>

<script>
import AppButton from '@/components/htmlHelpers/AppButton'
export default {
  components: {
    AppButton
  },
  name: 'AppToggleSelect',
  props: {
    // Pass from parent as v-model directive
    value: {
      type: [String, Number],
      default: 0
    },
    // Array of Objects.
    // [{value<String, Number>: 'private' / 1, text<String>: 'private', icon<String(valid fa icon name)>: comment}]
    // value - required, text / icon - at least one required
    options: {
      type: Array,
      required: true
    },
    // Decrease the size of buttons
    small: {
      type: Boolean,
      default: false
    },
    // Shows only icons in buttons. Make buttons square
    iconsOnly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    blockWidth () {
      return `calc(100% - ${this.options.length - 1}px)`
    },
    buttonWidth () {
      return `${(100 / this.options.length).toFixed(2)}%`
    }
  },
  methods: {
    onOptionClick (value) {
      // will update parents v-model
      if (value !== this.value) { this.$emit('input', value) }
    }
  }
}
</script>

<style scoped lang="scss">
  .toggle-switch {
    width: 100%;
    &.icons-only {
      width: fit-content;
    }
  }
  .toggle-switch__item {
    &:not(:first-child) {
      margin-left: 0;
    }
  }

html[dir="rtl"] {
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn {
    @include border-radius(0 rem-calc(4) rem-calc(4) 0)
  }

  .btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
    @include border-radius(rem-calc(4) 0 0 rem-calc(4))
  }
}
</style>
